/**
 * Shared billing-account scoping for the account-scoped billing surfaces
 * (top-up shop, payment history). A page always targets exactly ONE billing
 * account: personal → the caller's personal account (organisationId == null);
 * organisation → the account belonging to the given organisation.
 */

import type { BillableAccount } from "@/services/billingApi";

/**
 * Which billing account a scoped billing section targets. Personal targets the
 * caller's personal account (organisationId == null); organisation targets the
 * account belonging to the given organisation.
 */
export type BillingAccountScope =
  { kind: "personal" } | { kind: "organisation"; organisationId: string };

/** Resolve the single billable account that matches the given scope. */
export function resolveScopedAccount(
  accounts: BillableAccount[],
  scope: BillingAccountScope,
): BillableAccount | null {
  const matches = accounts.filter((account) =>
    scope.kind === "personal"
      ? account.organisationId == null
      : account.organisationId === scope.organisationId,
  );
  return matches.find((account) => account.isDefault) ?? matches[0] ?? null;
}
